module.exports = __webpack_public_path__ + "static/loader-8a069a307af565ba573f40d5a6ed8ac9.gif";